var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00406265 11.09L1.41406 12.5L7.41406 6.5L1.41406 0.5L0.00406265 1.91L4.58406 6.5L0.00406265 11.09ZM6.00406 11.09L7.41406 12.5L13.4141 6.5L7.41406 0.5L6.00406 1.91L10.5841 6.5L6.00406 11.09Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRightBlack);
export default __webpack_public_path__ + "static/media/page-right-black.b5365c9596e29118524829614d5f24d3.svg";
export { ForwardRef as ReactComponent };